var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 64,
    viewBox: "0 0 307 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_1585)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_1585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 66,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0696 36.2722L36.3115 -0.000488281L-0.00146184 27.7268L27.7567 63.9995L64.0696 36.2722Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1099 15.2428L24.2645 27.4265L10.3603 27.5822L10.1818 27.5839L10.3131 39.5609L10.3147 39.7392L24.3974 39.5818L24.552 51.7655L60.1925 33.2616L60.5195 33.1016L24.1099 15.2428ZM14.2173 31.5064L26.2076 31.3753L28.3 31.349L28.2603 29.3589C28.2603 29.3589 28.2273 27.3189 28.1994 25.0505L28.1683 21.6621L51.6712 33.1683L28.4559 45.2377L28.3242 35.5508L14.2416 35.7082L14.1889 31.528L14.2173 31.5064Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_43_1585)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_43_1585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: -1,
    width: 65,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.77 36.2722L117.012 -0.000488281L80.6987 27.7268L108.457 63.9995L144.77 36.2722Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_43_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.812 15.2427L104.967 27.4264L91.0625 27.5821L90.8839 27.5838L91.0152 39.5607L91.0168 39.7391L105.1 39.5817L105.254 51.7653L140.895 33.2615L141.222 33.1015L104.812 15.2427ZM94.9195 31.5063L106.91 31.3751L109.002 31.3489L108.962 29.3588C108.962 29.3588 108.929 27.3187 108.902 25.0504L108.87 21.6619L132.373 33.1682L109.158 45.2376L109.026 35.5506L94.9437 35.708L94.8911 31.5279L94.9195 31.5063Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_43_1585)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_43_1585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 161,
    y: 0,
    width: 65,
    height: 64
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.473 36.2727L197.715 0L161.402 27.7273L189.16 64L225.473 36.2727Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_43_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.514 15.2426L185.669 27.4262L171.765 27.582L171.586 27.5836L171.717 39.5606L171.719 39.739L185.802 39.5816L185.956 51.7652L221.597 33.2613L221.924 33.1014L185.514 15.2426ZM175.622 31.5061L187.612 31.375L189.704 31.3487L189.665 29.3587C189.665 29.3587 189.632 27.3186 189.604 25.0502L189.573 21.6618L213.075 33.1681L189.86 45.2374L189.729 35.5505L175.646 35.7079L175.593 31.5278L175.622 31.5061Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_43_1585)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_43_1585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: -1,
    width: 65,
    height: 65
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M306.177 36.2722L278.419 -0.000488281L242.106 27.7268L269.864 63.9995L306.177 36.2722Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_43_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.217 15.2428L266.372 27.4265L252.468 27.5822L252.289 27.5839L252.42 39.5609L252.422 39.7392L266.505 39.5818L266.659 51.7655L302.3 33.2616L302.627 33.1016L266.217 15.2428ZM256.325 31.5064L268.315 31.3753L270.407 31.349L270.368 29.3589C270.368 29.3589 270.335 27.3189 270.307 25.0505L270.276 21.6621L293.779 33.1683L270.563 45.2377L270.432 35.5508L256.349 35.7082L256.296 31.528L256.325 31.5064Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_1585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.6752,
    height: 45.6885,
    fill: "white",
    transform: "matrix(0.607729 0.794145 -0.794795 0.606878 36.3125 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_43_1585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.6752,
    height: 45.6885,
    fill: "white",
    transform: "matrix(0.607729 0.794145 -0.794795 0.606878 117.014 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_43_1585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.6752,
    height: 45.6885,
    fill: "white",
    transform: "matrix(0.607729 0.794145 -0.794795 0.606878 197.715 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_43_1585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.6752,
    height: 45.6885,
    fill: "white",
    transform: "matrix(0.607729 0.794145 -0.794795 0.606878 278.418 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.99c90922f205fbec62b3eb28638721ea.svg";
export { ForwardRef as ReactComponent };